import { Box, Tooltip } from '@chakra-ui/react';
import { Button } from '@kula-ai/components';
import { Attachment02, Send01, Stop } from '@kula-ai/icons-core';
import type { ComposerActionsProps } from './Composer.types';
import { COMPOSER_ATTACHMENT_HELP } from './attachmentPolicy';

export function ComposerActions({
  canSend,
  sendDisabled = false,
  onSend,
  onAttach,
  awaiting = false,
  onStop,
  stopping = false,
}: ComposerActionsProps): JSX.Element {
  return (
    <Box display="flex" alignItems="center" gap="4px">
      <Tooltip label={COMPOSER_ATTACHMENT_HELP} placement="top" hasArrow>
        <Button
          size="icon"
          variant="quaternary"
          aria-label="Attach file"
          className="text-secondary-700 !border-0"
          onClick={onAttach}
        >
          <Attachment02 size={16} color="currentColor" />
        </Button>
      </Tooltip>
      {awaiting && onStop ? (
        // Claude-style Stop: while the agent works, the send slot becomes
        // a stop control — cancelling must never cost more than a click.
        <Button
          size="icon"
          aria-label="Stop generating"
          disabled={stopping}
          onClick={onStop}
          className="bg-secondary-900 text-base-white hover:bg-secondary-700"
          data-test-id="composer-stop"
        >
          <Stop size={16} color="currentColor" />
        </Button>
      ) : (
        <Button
          size="icon"
          aria-label="Send"
          disabled={!canSend || sendDisabled}
          onClick={onSend}
          className="bg-secondary-900 text-base-white disabled:bg-secondary-50 disabled:text-secondary-400 hover:bg-secondary-900"
        >
          <Send01 size={16} color="currentColor" />
        </Button>
      )}
    </Box>
  );
}
